import { SupportedDailyWeeklyRentalTypes } from 'enums/supportedRentalTypes';
import { dateService } from 'services/DateService';
import { VehicleBasedDailyWeeklyDemandState } from 'types/demand.type';
import { DailyWeeklyRentalInfo } from 'types/vehicle.type';
import { getDWDuration } from 'utils/getDWDuration';

export function usePriceWidgetCalculateDWDuration(
  rentalInfo: DailyWeeklyRentalInfo
) {
  const dayjs = dateService.getDayjs();
  const calculateDWDemandVariant = (
    state: VehicleBasedDailyWeeklyDemandState
  ): SupportedDailyWeeklyRentalTypes => {
    if (rentalInfo.supportedRentalTypes.length === 1) {
      return rentalInfo.supportedRentalTypes[0];
    }
    if (
      dateService.getDayDuration(state.startDate!, state.endDate!) === 0 &&
      state.demandVariant === SupportedDailyWeeklyRentalTypes.HALF_DAY
    ) {
      return SupportedDailyWeeklyRentalTypes.HALF_DAY;
    }
    const isDurationWeekly =
      dateService.getDayDuration(state.startDate!, state.endDate!) % 7 === 0;
    const isDatesAligned =
      dateService.getDayIndexAlignedWithDayjs(rentalInfo.checkInDay) ===
        state.startDate!.getDay() &&
      dateService.getDayIndexAlignedWithDayjs(rentalInfo.checkOutDay) ===
        state.endDate!.getDay();

    return isDurationWeekly && isDatesAligned
      ? SupportedDailyWeeklyRentalTypes.WEEKLY
      : SupportedDailyWeeklyRentalTypes.DAILY;
  };

  const getDemandDWDuration = (
    state: VehicleBasedDailyWeeklyDemandState
  ): number => {
    return getDWDuration(state.startDate!, state.endDate!, state.demandVariant);
  };

  const formatDatesToCorrectHours = (
    state: VehicleBasedDailyWeeklyDemandState
  ) => {
    const startDate =
      state.demandVariant === SupportedDailyWeeklyRentalTypes.HALF_DAY
        ? dayjs(state.startDate!).hour(10).toDate()
        : dayjs(state.startDate!).hour(rentalInfo.checkInHour).toDate();
    const endDate =
      state.demandVariant === SupportedDailyWeeklyRentalTypes.HALF_DAY
        ? dayjs(state.endDate!).hour(18).toDate()
        : dayjs(state.endDate!).hour(rentalInfo.checkOutHour).toDate();
    return {
      startDate,
      endDate,
    };
  };

  return {
    calculateDWDemandVariant,
    getDemandDWDuration,
    formatDatesToCorrectHours,
  };
}
